import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as echarts from 'echarts'
import { EChartsOption } from 'echarts'
import { onMounted, ref, withDefaults, watchEffect } from 'vue'
import useEchart from '@/Base-UI/echarts/hooks/useEcharts'
/* 定义props */

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  setup(__props: any) {

const props = __props as {
  options: EChartsOption
}



const echartsRef = ref<HTMLElement>()
onMounted(() => {
  const { setOptions } = useEchart(echartsRef.value!)
  /* 当props.options值改变刷新数据 */
  watchEffect(() => {
    setOptions(props.options)
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "base-eacharts",
    ref_key: "echartsRef",
    ref: echartsRef,
    style: { width: '100%', height: '360px' }
  }, null, 512))
}
}

})